import { FormControl, FormLabel, Input } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';

interface IProps {
	label: string;
	value: string;
	isLoading: boolean;
	onChange: (value: string) => void;
}

export default function TranslatedField(props: IProps) {
	const form = useForm({
		defaultValues: { value: props.value },
	});

	return (
		<FormControl>
			<FormLabel>{props.label}</FormLabel>
			<Input
				{...form.register('value')}
				onBlur={(e) => props.onChange(e.target.value)}
				isDisabled={props.isLoading}
				size="sm"
				type="text"
			/>
		</FormControl>
	);
}
